import { createFileRoute } from '@tanstack/react-router';
import { AdminVerificationQueuePage } from '../../features/verification';

export const Route = createFileRoute('/admin/verification/')({ component: AdminVerificationQueuePage });
